import * as React from 'react';
const FormsContext = React.createContext(null);
export const useFormsContext = () => React.useContext(FormsContext);
export const FormsProvider = ({ children }) => {
    const [isMultiCity, setIsMultiCity] = React.useState(false);
    const onChangeMultiCity = (value) => {
        setIsMultiCity(value);
    };
    return React.createElement(FormsContext.Provider, { value: { isMultiCity, onChangeMultiCity } }, children);
};
